import { tuscanCoveHomepageFaq } from "@/lib/tuscan-cove-content";
import { cn } from "@/lib/utils";

type HomeCompactFaqProps = {
  className?: string;
  items?: readonly {
    question: string;
    answer: string;
  }[];
};

export function HomeCompactFaq({
  className,
  items = tuscanCoveHomepageFaq,
}: HomeCompactFaqProps) {
  return (
    <section
      className={cn(
        "bg-[var(--roma-ivory)] px-4 py-12 text-[var(--roma-espresso)] sm:px-8 sm:py-16 lg:px-12 lg:py-20",
        className,
      )}
    >
      <div className="mx-auto max-w-3xl">
        <h2 className="font-serif text-[clamp(1.85rem,6vw,2.35rem)] font-normal leading-[1.1] tracking-tight text-[var(--roma-espresso)]">
          Before you visit
        </h2>

        <div className="mt-6 divide-y divide-[var(--roma-parchment-line)] border-y border-[var(--roma-parchment-line)] sm:mt-8">
          {items.map((item) => (
            <details key={item.question} className="group">
              <summary className="flex min-h-12 cursor-pointer list-none items-center justify-between gap-4 py-5 text-left text-base font-semibold text-[var(--roma-espresso)] marker:hidden">
                <span>{item.question}</span>
                <span
                  aria-hidden="true"
                  className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-[var(--roma-parchment-line)] text-sm leading-none text-[var(--roma-terracotta)] transition-transform group-open:rotate-45"
                >
                  +
                </span>
              </summary>
              <p className="pb-5 pr-10 text-sm leading-relaxed text-[var(--roma-espresso)]/70 sm:text-base">
                {item.answer}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HomeCompactFaq;
